var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useReducer } from "react";
import translate from "../../../i18n/translate";
import Loader from "../../common/elements/Loader";
import { WmButton } from "@watermarkinsights/ripple-react";
import { downloadPDF } from "../../common/helper";
import { sendRequest, sendRequestWithPayload } from "../../../common/http";
import { useIntl } from "react-intl";
var defaultHeaderAction = {
    type: "",
    token: "",
    data: false
};
var reducer = function (state, action) {
    switch (action.type) {
        case "setToken":
            return __assign(__assign({}, state), { token: action.token });
        case "setExportInProgress":
            return __assign(__assign({}, state), { isExportInProgress: action.data });
        default:
            return state;
    }
};
export default function Header(_a) {
    var showLoader = _a.showLoader, title = _a.title, planType = _a.planType, showDownloadBtn = _a.showDownloadBtn;
    var initialState = {
        token: null,
        isExportInProgress: false
    };
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var subHeader = useIntl().formatMessage({
        id: "app.planParticipation.participationAssessment"
    });
    function exportToPdf() {
        var mainContent = document.getElementById("maincontent");
        var downloadText = document.querySelector(".download-text");
        if (downloadText) {
            downloadText.setAttribute("tabindex", "0");
            downloadText.focus();
        }
        if (mainContent) {
            var clone = mainContent.cloneNode(true);
            var headerSection = clone.firstChild;
            headerSection && clone.removeChild(headerSection);
            var wrapperDiv = document.createElement("div");
            wrapperDiv.appendChild(clone);
            var formData = new FormData();
            formData.append("html", wrapperDiv.outerHTML);
            formData.append("header", encodeURIComponent(subHeader));
            formData.append("sub_header", encodeURIComponent(title));
            formData.append("export_id", "plan-participation-export");
            formData.append("_csrf_token", state.token ? state.token : "");
            var applyResult = function (result) {
                var fileTitle = planType === 0
                    ? "Participation_in_Program_Plans"
                    : "Participation_in_Course_Plans";
                downloadPDF(result.pdfFileBytes, fileTitle);
                dispatch(__assign(__assign({}, defaultHeaderAction), { type: "setToken", token: null }));
                dispatch(__assign(__assign({}, defaultHeaderAction), { type: "setExportInProgress", data: false }));
            };
            var onError = function (error) {
                // Log error in console for debugging
                console.log("API Error:", error);
                dispatch(__assign(__assign({}, defaultHeaderAction), { type: "setToken", token: null }));
                dispatch(__assign(__assign({}, defaultHeaderAction), { type: "setExportInProgress", data: false }));
            };
            sendRequestWithPayload({
                uri: "/export",
                body: formData,
                camelize: true
            }, applyResult, onError);
        }
    }
    useEffect(function () {
        if (state.isExportInProgress) {
            sendRequest({
                uri: "/export/token",
                camelize: true
            }, function (result) {
                dispatch(__assign(__assign({}, defaultHeaderAction), { type: "setToken", token: result.token }));
            });
        }
    }, [state.isExportInProgress]);
    useEffect(function () {
        if (state.token && state.isExportInProgress) {
            exportToPdf();
        }
    }, [state.isExportInProgress, state.token]);
    return (_jsxs(_Fragment, { children: [showLoader && _jsx(Loader, {}), _jsx("section", { className: "page-banner-container -mainheader -withbreadcrumbs only-breadcrumbs header-padding", id: "page-header", children: _jsxs("div", { className: "flex-row export-container", children: [_jsxs("div", { children: [_jsx("div", { children: _jsx("span", { className: "org-name uppercase", children: subHeader }) }), _jsx("div", { className: "identity-details", children: _jsx("div", { className: "page-header -titleonly", children: _jsx("h2", { className: "plan-title-header", children: title }) }) })] }), showDownloadBtn && (_jsxs("div", { className: "flex-row export-button", children: [state.isExportInProgress && (_jsx("span", { className: "download-text", children: translate("app.planParticipation.exportPdf.downloadReportText") })), _jsx("div", { className: "button-container", children: _jsx(WmButton, { "button-type": "secondary", icon: "f1da", "icon-size": "20px", onClick: function () {
                                            return dispatch(__assign(__assign({}, defaultHeaderAction), { type: "setExportInProgress", data: true }));
                                        }, disabled: state.isExportInProgress, children: translate("app.planParticipation.exportPdf.download") }) })] }))] }) })] }));
}
